import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LanguageSwitcherPopupComponent } from '../language-switcher/language-switcher-popup.component';
import { LanguageService } from '../services/language.service';
import { ToggleService } from '../services/toggle.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-account-settings-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
})
export class AccountSettingsUserSettingsComponent implements OnInit, OnDestroy {
  public email = '';
  public currentLanguageInfo: any = { name: 'English', flag: '🇺🇸' };
  private languageSubscription?: Subscription;
  private storageSubscription?: Subscription;

  constructor(
    private navCtrl: NavController,
    private modalController: ModalController,
    private router: Router,
    private languageService: LanguageService,
    private toggleService: ToggleService,
    private userService: UserService,
    @Optional() @Inject('accountInformation') public accountInformation: any
  ) {}

  ngOnInit() {
    const loginData = this.userService.getLoginData();
    this.email = loginData?.email || '';
    if (!this.email) {
      this.userService.getStoredEmail();
      this.storageSubscription = this.userService.storageUpdate.subscribe((data) => {
        if (data?.email) {
          this.email = data.email;
        }
      });
    }

    this.currentLanguageInfo = this.languageService.getCurrentLanguageInfo();
    this.languageSubscription = this.languageService.currentLanguage$.subscribe(() => {
      this.currentLanguageInfo = this.languageService.getCurrentLanguageInfo();
    });
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
    if (this.storageSubscription) {
      this.storageSubscription.unsubscribe();
    }
  }

  isToggleEnabled(toggleName: string): boolean {
    return this.toggleService.isToggleEnabled(toggleName);
  }

  currentAccountLabel(): string {
    return this.accountInformation?.company?.name
      || this.accountInformation?.general?.external_id
      || '';
  }

  async openLanguageSwitcher() {
    if (!this.isToggleEnabled('internationalization')) {
      return;
    }
    const modal = await this.modalController.create({
      component: LanguageSwitcherPopupComponent,
      componentProps: {},
      cssClass: 'language-switcher-modal',
    });
    return await modal.present();
  }

  goToChangePassword() {
    this.navCtrl.navigateForward('/change-password');
  }

  goToSwitchAccounts() {
    this.navCtrl.navigateForward('/switch-account');
  }

  goToAlertSettings() {
    this.router.navigate(['/account-admin'], { queryParams: { tab: 'alert-settings' } });
  }

  goToDeviceSettings() {
    this.router.navigate(['/account-admin'], { queryParams: { tab: 'users' } });
  }
}
